import axios from './client';

const CUSTOMER_BUSINESS_TYPES = '/customer/business-types';
const CUSTOMER_SPECIALIZATIONS = '/customer/specializations';


/**
 * get customer business types
 * @returns {Promise}
 */
export function getBusinessTypes() {
  return axios.get(CUSTOMER_BUSINESS_TYPES);
}
/**
 * get customer business specializations
 * @returns {Promise}
 */
export function getSpecializations() {
  return axios.get(CUSTOMER_SPECIALIZATIONS);
}
